export default class SettingService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getSettings () {
    return new Promise((resolve, reject) => {
      this.$http.get('settings')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createSetting (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('settings/create', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateSetting (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`settings/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteSetting (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`settings/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  // --- Store Receipt Settings ---
  getStoreReceiptSettings (storeId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`stores/${storeId}/receipt-settings`)
        .then(res => res.data)
        .then(data => {
          if (data.status !== 200) reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateStoreReceiptSettings (storeId, payload) {
    return new Promise((resolve, reject) => {
      this.$http.put(`stores/${storeId}/receipt-settings`, payload)
        .then(res => res.data)
        .then(data => {
          if (data.status !== 200) reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  // --- Store Receipts ---
  getStoreReceipts (storeId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`stores/${storeId}/receipts`)
        .then(res => res.data)
        .then(data => {
          if (data.status !== 200) reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createStoreReceipt (storeId, payload) {
    return new Promise((resolve, reject) => {
      this.$http.post(`stores/${storeId}/receipts`, payload)
        .then(res => res.data)
        .then(data => {
          if (data.status !== 201) reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateStoreReceipt (receiptId, payload) {
    return new Promise((resolve, reject) => {
      this.$http.put(`receipts/${receiptId}`, payload)
        .then(res => res.data)
        .then(data => {
          if (data.status !== 200) reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteStoreReceipt (receiptId) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`receipts/${receiptId}`)
        .then(res => res.data)
        .then(data => {
          if (data.status !== 200) reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  toggleStoreReceiptActive (receiptId) {
    return new Promise((resolve, reject) => {
      this.$http.patch(`receipts/${receiptId}/activate`)
        .then(res => res.data)
        .then(data => {
          if (data.status !== 200) reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
